<template>
  <div class="mb-6 border-b border-solid border-gray-500">
    <ul
      class="scrollbar-h-px extend-width flex w-full overflow-y-hidden overflow-x-scroll desktop:overflow-x-hidden"
    >
      <li v-for="(item, index) in tabs" :key="index" class="px-4">
        <button
          class="relative py-3 after:absolute after:bottom-0 after:left-0 after:block after:h-1.5 after:w-full after:rounded-t-lg after:bg-blue-400 after:opacity-0 after:content-[''] hover:text-blue-400"
          :class="model === index && 'text-blue-400 after:opacity-100'"
          :title="item"
          @click="model = index"
        >
          <span class="truncate text-lg font-bold leading-8">
            {{ item }}
          </span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  interface IProps {
    tabs: string[];
  }

  defineProps<IProps>();

  const model = defineModel<number>({ default: 0 });
</script>
